import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { LibraryType } from "./library.model";
import { UsersService } from "../users/users.service";

@Component({
    selector: "app-library",
    templateUrl: "./library.component.html",
    styleUrls: ["./library.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LibraryComponent {
  private usersService = inject(UsersService);

  libraryLoaded: boolean | null = null;
  LibraryT = LibraryType;

  loadDocumentsFromServer() {
    this.libraryLoaded = true;
    this.usersService.getServiceman().subscribe();
  }

  clearRefresh() {
    this.libraryLoaded = false;
  }
}
